import { render, staticRenderFns } from "./JobEndedTaskItem.vue?vue&type=template&id=08e7ecf8&"
import script from "./JobEndedTaskItem.vue?vue&type=script&lang=js&"
export * from "./JobEndedTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports